/**
 * App component - Root with telemetry initialization
 */

import React from 'react';
import DashboardLayout from './components/DashboardLayout';
import { initializeTelemetry } from './telemetry/TelemetryClient';
import { TelemetryConfig } from './telemetry/TelemetryConfig';
import { useTelemetryUserContext } from './hooks/useTelemetryUserContext';
import { useDeploymentPolling } from './hooks/useDeploymentPolling';

// Initialize telemetry when this module loads
try {
  initializeTelemetry(TelemetryConfig);
} catch {
  // Telemetry initialization is non-critical; app continues without it
}

const AppWithTelemetry: React.FC = () => {
  useTelemetryUserContext();
  useDeploymentPolling();
  return <DashboardLayout />;
};

const App: React.FC = () => {
  return <AppWithTelemetry />;
};

export default App;